<template>
  <div class="allInOneContent">
    <div class="topBox">
      <div class="topTitle">综合传感器</div>
      <!-- <div class="topText">STW32/43/49-V5</div> -->
      <img :src="AllInOne1" class="topImg" alt>
    </div>
    <div class="allInOneParent" style="margin-top:104px;">
      <div class="allInOneLeft">
        <div class="boxTitleBox">
          <div class="boxTitle">1080p像素</div>
          <div class="boxTitleLine"></div>
        </div>
        <div class="boxP">像素由720P升级为1080p，像素更清晰，WDR宽动态，即使逆光也能保留更多细节。</div>
      </div>
      <div class="allInOneRight">
        <img :src="AllInOne2" alt>
      </div>
    </div>
    <!-- start -->
    <div class="allInOneParent marginTop100">
      <div class="allInOneLeft" style="width:50%;padding-left:0;">
        <img :src="AllInOne4" class="leftImg1" alt>
      </div>
      <div class="allInOneRight" style="width:40%;padding-left:10%;">
        <div class="boxTitleBox">
          <div class="boxTitle">人群属性识别</div>
          <div class="boxTitleLine"></div>
        </div>
        <div class="boxP">数拓自制，集成距离传感器与高清摄像头，实现在识别范围内，分析人群年龄，性别，表情，是否会员等属性。</div>
      </div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="allInOneParent marginTop100">
      <div class="allInOneLeft">
        <div class="boxTitleBox">
          <div class="boxTitle">微光全彩技术</div>
          <div class="boxTitleLine"></div>
        </div>
        <div class="boxP">
          即使在微弱光线下也能看到彩色图像。而在同样情况下，其他摄像头智能换为黑白图像。
        </div>
      </div>
      <div class="allInOneRight">
        <img :src="AllInOne3" alt>
      </div>
    </div>
    <!-- end -->
   
  
    <div class="bottomImgBox">
      <img :src="AllInOne5" class alt>
    </div>
  </div>
</template>
<script>
import AllInOne1 from "@/assets/images/synthe1.png";
import AllInOne2 from "@/assets/images/synthe2.png";
import AllInOne3 from "@/assets/images/synthe3.png";
import AllInOne4 from "@/assets/images/synthe4.png";
import AllInOne5 from "@/assets/images/synthe5.png";
import AllInOne6 from "@/assets/images/AllInOne6.png";
import AllInOne7 from "@/assets/images/AllInOne7.png";
import AllInOne8 from "@/assets/images/AllInOne8.png";
import AllInOne9 from "@/assets/images/AllInOne9.png";
export default {
  data() {
    return {
      AllInOne1: AllInOne1,
      AllInOne2: AllInOne2,
      AllInOne3: AllInOne3,
      AllInOne4: AllInOne4,
      AllInOne5: AllInOne5,
      AllInOne6: AllInOne6,
      AllInOne7: AllInOne7,
      AllInOne8: AllInOne8,
      AllInOne9: AllInOne9
    };
  }
};
</script>
<style scoped>
.allInOneContent {
  width: 70%;
  margin: auto;
  font-size: 0;
}
.topBox {
  text-align: center;
  margin-top: 114px;
}
.topTitle {
  font-size: 4rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(88, 89, 89, 1);
}
.topText {
  margin-top: 20px;
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(153, 153, 153, 1);
}
.topImg {
  width: 50%;
  max-width: 648px;
  margin-top: 20px;
}
/* start */
.boxTitle {
  font-size: 4rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  margin-top: 30%;
}
.boxTitleLine {
  width: 80px;
  height: 4px;
  margin-top: 20px;
  background: rgba(252, 200, 0, 1);
}
/* end */
.allInOneParent::after {
  content: "";
  display: block;
  clear: both;
}
.allInOneParent {
  margin-top: 20px;
}
.allInOneLeft {
  width: 40%;
  padding-left: 10%;
  float: left;
}
.boxTitleBox {
}
.allInOneRight {
  width: 50%;
  float: left;
}
.allInOneRight img {
  width: 100%;
}
.boxP {
  width: 70%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  margin-top: 40px;
  line-height: 40px;
  text-align: left;
}
.leftImg1 {
  width: 100%;
 
}
.marginTop100 {
  margin-top: 0px;
}
.bottomImgBox {
  margin-top: 105px;
  text-align: center;
}
.bottomImgBox img {
  width: 100%;
  max-width: 1200px;
}
.textCenter {
  text-align: center;
}
.marginAuto {
  margin: auto;
  margin-top: 20px;
}
.marginTop28 {
  margin-top: 28px;
}
.marginTop40 {
  margin-top: 40px;
}
</style>





// WEBPACK FOOTER //
// src/view/hardware/synthesize.vue